import { getBizLanguage } from "./i18n";
import { checkWin, supportedEntryType } from ".";
import parseEagleeyeId from "./parseEagleeyeId";
var getNetworkSpentTime = function() {
    if (supportedEntryType("navigation")) {
        var navigationTiming = performance.getEntriesByType("navigation")[0];
        if (navigationTiming) {
            var ttfb = navigationTiming.responseStart - navigationTiming.fetchStart;
            var appDuration = 0;
            if (Array.isArray(navigationTiming.serverTiming)) {
                navigationTiming.serverTiming.forEach(function(item) {
                    if (item.name === "app") {
                        appDuration = item.duration;
                    }
                });
            }
            if (appDuration > 0 && ttfb > appDuration) {
                return ttfb - appDuration;
            }
            return ttfb;
        }
    } else if (checkWin() && window.performance && window.performance.timing) {
        var timing = window.performance.timing;
        return timing.responseStart - timing.fetchStart;
    }
    return 0;
};
var getPageResponseAserverIp = function() {
    if (supportedEntryType("navigation")) {
        var navigationTiming = performance.getEntriesByType("navigation")[0];
        if (navigationTiming) {
            if (Array.isArray(navigationTiming.serverTiming)) {
                var aServerIp = null;
                navigationTiming.serverTiming.forEach(function(item) {
                    if (item.name === "traceId" && item.description) {
                        var _result;
                        var result = parseEagleeyeId(item.description);
                        aServerIp = ((_result = result) === null || _result === void 0 ? void 0 : _result.aserver) || null;
                    }
                });
                return aServerIp;
            }
        }
    }
    return null;
};
var isInIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return false;
    }
};
export var getClientExtraInfo = function() {
    // 获取时区
    var timezone;
    var timezoneArea;
    var locale;
    try {
        var dateIns = new Date();
        if (typeof dateIns.getTimezoneOffset === "function") {
            var hourOffset = 0 - Math.ceil(dateIns.getTimezoneOffset() / 60);
            timezone = "UTC".concat(hourOffset > 0 ? "+" : "").concat(hourOffset);
        }
        var intlResolvedOptions = {};
        try {
            var _Intl;
            intlResolvedOptions = ((_Intl = Intl) === null || _Intl === void 0 ? void 0 : _Intl.DateTimeFormat().resolvedOptions()) || {};
        } catch (e) {
        // ignore
        }
        timezoneArea = intlResolvedOptions.timeZone;
        locale = intlResolvedOptions.locale;
        // 纠正 Chrome 存在的时区信息获取错误 bug
        // @link https://support.google.com/chrome/thread/232962259/chrome-displaying-wrong-time-zone?hl=en
        if (timezone === "UTC+8" && new Date().toString().toLowerCase().indexOf("gmt+0800") > -1 && (!timezoneArea || timezoneArea.indexOf("Europe") > -1 || timezoneArea.indexOf("America") > -1)) {
            timezoneArea = "Asia/Shanghai";
        }
    } catch (e) {
    // ignore
    }
    // 获取语言
    var language;
    try {
        language = navigator.language || undefined;
    } catch (e) {
    // ignore
    }
    var result = {
        biz_language: getBizLanguage()
    };
    if (timezone) {
        result.timezone = timezone;
    }
    if (language) {
        result.language = language;
    }
    if (timezoneArea) {
        result.timezone_area = timezoneArea;
    }
    if (locale) {
        result.locale = locale;
    }
    try {
        var networkSpentTime = getNetworkSpentTime();
        if (networkSpentTime > 0) {
            result.page_load_network_spent_time = networkSpentTime;
        }
    } catch (e) {
    // ignore
    }
    var aServerIp = getPageResponseAserverIp();
    if (aServerIp) {
        result.aserverIp = aServerIp;
    }
    if (checkWin()) {
        result.isInIframe = isInIframe();
    }
    return result;
};

 //# sourceMappingURL=client-extra-info.js.map